import React from 'react';
import './OrdersTable.css';
import Pagination from './Pagination';

const formatDate = (value) => {
  if (!value) return '-';
  const numeric = Number(value);
  const date = new Date(numeric && numeric < 1e12 ? numeric * 1000 : value);
  if (Number.isNaN(date.getTime())) return String(value);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span style={{ fontSize: '1rem', fontWeight: 600 }}>{day}.{month}.{year}</span>
      <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>{hours}:{minutes}:{seconds}</span>
    </div>
  );
};

const RequestsTable = ({ data = [], pagination, onPageChange }) => {
  const requests = Array.isArray(data) ? [...data] : [];
  requests.sort((a, b) => Number(b.create_time || 0) - Number(a.create_time || 0));

  const columns = [
    { key: 'created', label: 'Created', value: (item) => formatDate(item.create_time) },
    { key: 'orderId', label: 'Order ID', value: (item) => item.orderId || '-' },
    { key: 'ref', label: 'Ref', value: (item) => item.ref || '-' }
  ];

  if (!requests.length) return <div className="orders-empty"><p>No data to display</p></div>;

  return (
    <div className="orders-table-container">
      <div className="table-wrapper">
        <table className="orders-table">
          <thead><tr>{columns.map((column) => <th key={column.key}>{column.label}</th>)}</tr></thead>
          <tbody>
            {requests.map((request, index) => (
              <tr key={request.ref || request.id || index} className="order-row">
                {columns.map((column) => (
                  <td key={column.key} data-label={column.label}>
                    {column.value(request)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pagination && onPageChange && (
        <Pagination
          currentPage={pagination.page}
          totalPages={pagination.totalPages}
          onPageChange={onPageChange}
          itemsPerPage={pagination.limit}
          totalItems={pagination.total}
        />
      )}
    </div>
  );
};

export default RequestsTable;
